module.exports = __webpack_public_path__ + "static/media/right-icon-arrow-disabled.fc082707.svg";